import noUiSlider from "nouislider"

document.addEventListener("DOMContentLoaded", function() {

    const rangeSlider = $(".js-range-slider");

    if(rangeSlider.length > 0){

        rangeSlider.each(function(){

            const slider = this,
                inputs = $(this).siblings(".js-range-inputs"),
                input1Node= inputs.find(".js-range-start"),
                input2Node= inputs.find(".js-range-end");

            let minPrice = $(slider).data("min"),
                maxPrice = $(slider).data("max"),
                rangeStart = $(slider).data("start"),
                rangeEnd = $(slider).data("end");

            noUiSlider.create(slider, {
                animationDuration: 300,
                start: [rangeStart, rangeEnd],
                step: 5,
                connect: true,
                range: {
                    "min": minPrice,
                    "max": maxPrice
                },
            });

            slider.noUiSlider.on("update", function( values) {
                var start = parseInt(values[0]);
                var end = parseInt(values[1]);

                input1Node.val(start);
                input2Node.val(end);
            });

            input1Node.on("change", function() {
                slider.noUiSlider.set([this.value, null]);
            });

            input2Node.on("change", function() {
                slider.noUiSlider.set([null, this.value]);
            });
        });
    }
});